import { render, staticRenderFns } from "./AtomProjectSliderThumb.vue?vue&type=template&id=066df313&scoped=true&"
import script from "./AtomProjectSliderThumb.vue?vue&type=script&lang=js&"
export * from "./AtomProjectSliderThumb.vue?vue&type=script&lang=js&"
import style0 from "./AtomProjectSliderThumb.vue?vue&type=style&index=0&id=066df313&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066df313",
  null
  
)

export default component.exports